const glossBlue = {
  color: "#3a4fc4",
  metalness: 0.28,
  roughness: 0.28,
  clearcoat: 1,
  clearcoatRoughness: 0.08,
  envMapIntensity: 1.05
};
const dustyOchre = {
  color: "#c4a574",
  metalness: 0.2,
  roughness: 0.55,
  clearcoat: 0.35,
  clearcoatRoughness: 0.45
};
const nearBlack = {
  color: "#1a1d22",
  metalness: 0.25,
  roughness: 0.6,
  clearcoat: 0.15,
  clearcoatRoughness: 0.7
};
const dustyRails = {
  color: "#3a3f46",
  metalness: 0.15,
  roughness: 0.9,
  clearcoat: 0.05,
  clearcoatRoughness: 0.85
};
const amberMarker = {
  color: "#f0a020",
  metalness: 0.1,
  roughness: 0.3,
  clearcoat: 0.4,
  clearcoatRoughness: 0.4,
  emissive: "#7a4a00",
  emissiveIntensity: 0.9
};
const ivory = {
  color: "#ece6d4",
  metalness: 0.2,
  roughness: 0.32,
  clearcoat: 1,
  clearcoatRoughness: 0.1,
  envMapIntensity: 1.05
};
const chalkyCement = {
  color: "#9a958c",
  metalness: 0.08,
  roughness: 0.82,
  clearcoat: 0.04,
  clearcoatRoughness: 0.92
};
const oilyRails = {
  color: "#2c2a28",
  metalness: 0.35,
  roughness: 0.55,
  clearcoat: 0.1,
  clearcoatRoughness: 0.7
};
const whiteCab = {
  color: "#d5e0d8",
  metalness: 0.22,
  roughness: 0.28,
  clearcoat: 1,
  clearcoatRoughness: 0.08,
  envMapIntensity: 1.05
};
const darkGreen = {
  color: "#1f5c3a",
  metalness: 0.2,
  roughness: 0.62,
  clearcoat: 0.2,
  clearcoatRoughness: 0.55
};
const paleDoor = {
  color: "#d5d0c4",
  metalness: 0.15,
  roughness: 0.45,
  clearcoat: 0.3,
  clearcoatRoughness: 0.4
};
const aluminium = {
  color: "#c5cdd4",
  metalness: 0.78,
  roughness: 0.28,
  clearcoat: 0.35,
  clearcoatRoughness: 0.35,
  envMapIntensity: 1.15
};
const maroon = {
  color: "#6b1d2a",
  metalness: 0.25,
  roughness: 0.4,
  clearcoat: 0.6,
  clearcoatRoughness: 0.25
};
const destination = {
  color: "#1a1d22",
  metalness: 0.1,
  roughness: 0.35,
  clearcoat: 0.2,
  clearcoatRoughness: 0.5,
  emissive: "#d4c48a",
  emissiveIntensity: 0.85
};
const gunmetal = {
  color: "#5a5e64",
  metalness: 0.6,
  roughness: 0.28,
  clearcoat: 1,
  clearcoatRoughness: 0.12,
  envMapIntensity: 1.25
};
const glossBlack = {
  color: "#141518",
  metalness: 0.4,
  roughness: 0.18,
  clearcoat: 1,
  clearcoatRoughness: 0.08
};
const chrome = {
  color: "#c8d0d8",
  metalness: 0.92,
  roughness: 0.16,
  clearcoat: 1,
  clearcoatRoughness: 0.08,
  envMapIntensity: 1.2
};
const tailBar = {
  color: "#8e2126",
  metalness: 0.3,
  roughness: 0.12,
  clearcoat: 1,
  clearcoatRoughness: 0.1,
  emissive: "#3a0a0c",
  emissiveIntensity: 0.7
};
const machineYellow = {
  color: "#e0a021",
  metalness: 0.35,
  roughness: 0.44,
  clearcoat: 0.5,
  clearcoatRoughness: 0.3
};
const plantYellowDark = {
  color: "#5a4a20",
  metalness: 0.3,
  roughness: 0.55,
  clearcoat: 0.35,
  clearcoatRoughness: 0.45
};
const jcbTrim = {
  color: "#23272d",
  metalness: 0.25,
  roughness: 0.6,
  clearcoat: 0.1,
  clearcoatRoughness: 0.7
};
const jcbBeacon = {
  color: "#f0a020",
  metalness: 0.1,
  roughness: 0.3,
  clearcoat: 0.2,
  clearcoatRoughness: 0.5,
  emissive: "#7a4a00",
  emissiveIntensity: 0.9
};
const PALETTES = {
  truck: {
    body: glossBlue,
    secondary: dustyOchre,
    edge: nearBlack,
    chassis: dustyRails,
    accent: amberMarker
  },
  mixer: {
    body: whiteCab,
    secondary: chalkyCement,
    edge: nearBlack,
    chassis: oilyRails,
    accent: amberMarker
  },
  trailer: {
    body: darkGreen,
    secondary: paleDoor,
    edge: aluminium,
    chassis: dustyRails,
    accent: amberMarker
  },
  bus: {
    body: ivory,
    secondary: maroon,
    edge: nearBlack,
    chassis: dustyRails,
    accent: destination
  },
  car: {
    body: gunmetal,
    secondary: glossBlack,
    edge: chrome,
    chassis: dustyRails,
    accent: tailBar
  },
  jcb: {
    body: machineYellow,
    secondary: plantYellowDark,
    edge: jcbTrim,
    chassis: jcbTrim,
    accent: jcbBeacon
  },
  wheel_loader: {
    body: machineYellow,
    secondary: plantYellowDark,
    edge: jcbTrim,
    chassis: jcbTrim,
    accent: jcbBeacon
  },
  rigid_haul_truck: {
    body: glossBlue,
    secondary: dustyOchre,
    edge: nearBlack,
    chassis: dustyRails,
    accent: amberMarker
  },
  adt: {
    body: dustyOchre,
    secondary: plantYellowDark,
    edge: nearBlack,
    chassis: dustyRails,
    accent: amberMarker
  },
  water_tanker: {
    body: glossBlue,
    secondary: ivory,
    edge: aluminium,
    chassis: dustyRails,
    accent: amberMarker
  },
  fuel_bowser: { body: ivory, secondary: aluminium, edge: nearBlack, chassis: dustyRails, accent: amberMarker },
  service_vehicle: { body: whiteCab, secondary: ivory, edge: dustyRails, chassis: dustyRails, accent: amberMarker },
  motor_grader: { body: machineYellow, secondary: plantYellowDark, edge: jcbTrim, chassis: jcbTrim, accent: jcbBeacon },
  forklift: { body: machineYellow, secondary: plantYellowDark, edge: jcbTrim, chassis: jcbTrim, accent: jcbBeacon },
  telehandler: { body: machineYellow, secondary: plantYellowDark, edge: jcbTrim, chassis: jcbTrim, accent: jcbBeacon },
  tractor: { body: darkGreen, secondary: machineYellow, edge: nearBlack, chassis: dustyRails, accent: amberMarker },
  underground_lhd: { body: dustyOchre, secondary: plantYellowDark, edge: nearBlack, chassis: dustyRails, accent: amberMarker },
  underground_dumper: { body: dustyOchre, secondary: plantYellowDark, edge: nearBlack, chassis: dustyRails, accent: amberMarker },
  wheeled_excavator: { body: machineYellow, secondary: plantYellowDark, edge: jcbTrim, chassis: jcbTrim, accent: jcbBeacon },
  wheel_dozer: { body: machineYellow, secondary: plantYellowDark, edge: jcbTrim, chassis: jcbTrim, accent: jcbBeacon },
  wheeled_drill_rig: { body: dustyOchre, secondary: machineYellow, edge: nearBlack, chassis: dustyRails, accent: amberMarker },
  wheeled_crane: { body: glossBlue, secondary: dustyOchre, edge: nearBlack, chassis: dustyRails, accent: amberMarker },
  pneumatic_tyre_roller: { body: machineYellow, secondary: plantYellowDark, edge: jcbTrim, chassis: jcbTrim, accent: jcbBeacon }
};
const BODY_PALETTES = PALETTES;
const bodyPalette = (silhouette) => PALETTES[silhouette];
export {
  BODY_PALETTES,
  bodyPalette
};
